// Ubicación en el repo: src/components/RescheduleToast.jsx
// Aviso NO bloqueante tras cambiar la hora de una cita — ya sea arrastrando
// en la grilla o editando fecha/hora desde "Editar cita" (Agenda.jsx,
// handleDrop/handleFormSaved). Pedido de Nicolás (24-ago-2026): si el
// cambio fue presencial (el paciente está ahí mismo, cambiándose la hora
// en el mesón), no tiene sentido forzar un aviso; si fue remoto, conviene
// acordarse de avisarle. Por eso es un aviso que se puede ignorar sin
// consecuencia, no un modal que bloquee seguir trabajando en la Agenda.
//
// El botón "Avisar por correo" NO manda nada directo desde acá — dispara
// el mismo flujo ya existente de "Mandar recordatorio" (handleEmailReminder
// → SendReminderModal), que ya tiene su propio paso de confirmación antes
// del envío real. Se reutiliza a propósito, en vez de mandar el correo de
// un solo clic acá: mismo criterio de seguridad ya validado (evitar un
// correo real por un clic apurado), y el correo de recordatorio ya muestra
// fecha/hora/sucursal actualizadas — sirve tal cual para este caso.
import { useEffect } from 'react';
import { formatPatientName } from '../lib/format';

const AUTO_DISMISS_MS = 15000;

export default function RescheduleToast({ appointment, onNotify, onDismiss }) {
  useEffect(() => {
    const t = setTimeout(onDismiss, AUTO_DISMISS_MS);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [appointment]);

  return (
    <div className="reschedule-toast" role="status">
      <span className="reschedule-toast__text">
        Hora actualizada para <strong>{formatPatientName(appointment.patients)}</strong> —{' '}
        {appointment.time?.slice(0, 5)} hrs. Si el cambio no fue presencial, conviene avisarle.
      </span>
      <div className="reschedule-toast__actions">
        <button type="button" className="button-secondary" onClick={onDismiss}>
          Ahora no
        </button>
        <button type="button" className="button-primary" onClick={onNotify}>
          Avisar por correo
        </button>
      </div>
    </div>
  );
}
